/*
 * Copyright (c) 2025 Ping Identity Corporation. All rights reserved.
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
export function logger(config) {
    let logLevel = config.level || 'info';
    const custom = config.custom;
    // Implement log functions
    const logFunctions = {
        error: (...args) => custom?.error ? custom.error(...args) : console.error(...args),
        warn: (...args) => (custom?.warn ? custom.warn(...args) : console.warn(...args)),
        info: (...args) => (custom?.info ? custom.info(...args) : console.info(...args)),
        debug: (...args) => custom?.debug ? custom.debug(...args) : console.debug(...args),
    };
    // Implement level inclusion
    const shouldLog = (level, currentLevel) => {
        const levelMap = {
            error: 0,
            warn: 1,
            info: 2,
            debug: 3,
            none: -1,
        };
        return levelMap[level] <= levelMap[currentLevel] && levelMap[currentLevel] !== -1;
    };
    // Compose logger module
    return {
        changeLevel: (level) => {
            logLevel = level;
        },
        error: (...args) => {
            if (shouldLog('error', logLevel)) {
                logFunctions.error(...args);
            }
        },
        warn: (...args) => {
            if (shouldLog('warn', logLevel)) {
                logFunctions.warn(...args);
            }
        },
        info: (...args) => {
            if (shouldLog('info', logLevel)) {
                logFunctions.info(...args);
            }
        },
        debug: (...args) => {
            if (shouldLog('debug', logLevel)) {
                logFunctions.debug(...args);
            }
        },
    };
}
